import { render, staticRenderFns } from "./modal-production-posts.vue?vue&type=template&id=ecd19d2e&scoped=true&"
import script from "./modal-production-posts.vue?vue&type=script&lang=js&"
export * from "./modal-production-posts.vue?vue&type=script&lang=js&"
import style0 from "./modal-production-posts.vue?vue&type=style&index=0&id=ecd19d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd19d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecd19d2e')) {
      api.createRecord('ecd19d2e', component.options)
    } else {
      api.reload('ecd19d2e', component.options)
    }
    module.hot.accept("./modal-production-posts.vue?vue&type=template&id=ecd19d2e&scoped=true&", function () {
      api.rerender('ecd19d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/modal-production-posts.vue"
export default component.exports